import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
        flexDirection: 'row',
      },
    },
    btnWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 47,
      [theme.breakpoints.up('md')]: {
        '&:not(:last-child)': {
          paddingRight: SMALL_MARGIN,
          marginRight: SMALL_MARGIN,
          borderRight: `1px solid ${colorsPalette.violetAnalyticsCard}`,
        },
      },
    },
    btn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
      background: 'transparent',
      color: colorsPalette.white,
      lineHeight: 1,
      fontSize: 18,
      fontWeight: 'bold',
      cursor: 'pointer',
      '&:focus': {
        outline: 'none',
      },
    },
    btnText: {
      display: 'block',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
      [theme.breakpoints.up('xl')]: {
        display: 'block',
      },
    },
    icon: {
      width: 21,
      height: 21,
      marginRight: 9,
      [theme.breakpoints.up('md')]: {
        marginRight: 0,
      },
      [theme.breakpoints.up('xl')]: {
        marginRight: 9,
      },
    },
    customTooltip: {
      [theme.breakpoints.up('xl')]: {
        display: 'none',
      },
    },
    customTooltipPopper: {
      [theme.breakpoints.up('xl')]: {
        display: 'none',
      },
    },
  }),
);
export default useStyles;
